import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { Grid } from '@mui/material'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined'
import AddExtensionModal from './Modals/AddExtensionModal'
import DeleteExtensionModal from './Modals/DeleteExtensionModal'
import { useState } from 'react'
import useStyleSecurity from './Styles/useStyle'

export default function ListExtensions ({ lista }) {
  const classes = useStyleSecurity()

  const [openAddModal, setOpenAddModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [extendSelected, setextendSelected] = useState('')

  const handleClickOpenModalAdd = () => {
    setOpenAddModal(true)
  }

  const handleClickOpenModalDelete = () => {
    setOpenDeleteModal(true)
  }

  const handleChange = (event) => {
    setextendSelected(event.target.value)
  }

  return (
    <Grid container style={{ width: '100%' }}>
      <FormControl className={classes.formControl} size="small">
        <Select
          value={extendSelected}
          onChange={handleChange}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          {lista.length === 0
            ? (
            <MenuItem value="empty" disabled>
              No se encontraron extensiones
            </MenuItem>
              )
            : (
                lista.map((item) => {
                  return (
                <MenuItem
                  key={item.extensionCharCode}
                  value={item.extensionCharCode}
                >
                  {item.extensionCharCode}
                </MenuItem>
                  )
                })
              )}
        </Select>
      </FormControl>

      <Grid style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
        <AddBoxOutlinedIcon
          onClick={handleClickOpenModalAdd}
          sx={{ '&:hover': { bgcolor: '#E6E6E6', cursor: 'pointer' }, ml: 1 }}
        />
        {extendSelected !== ''
          ? (
          <IndeterminateCheckBoxOutlinedIcon
            onClick={handleClickOpenModalDelete}
            sx={{ '&:hover': { bgcolor: '#E6E6E6' } }}
          />
            )
          : null}
      </Grid>
      <AddExtensionModal
        openAddModal={openAddModal}
        setOpenAddModal={setOpenAddModal}
      />
      <DeleteExtensionModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        extendSelected={extendSelected}
      />
    </Grid>
  )
}
